import { jsx as _jsx } from "react/jsx-runtime";
import { getFilmAvailability, getFilmById, loadFilmAvailability, loadFilmById, LoadingState } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useLoadAction } from '@vista-digital/react-tools';
import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { useMemberRewards } from '../../hooks/use-member-rewards';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { useFilmSchema } from './hooks/use-film-schema';
import { FilmContextMessage, FilmContextMessageType } from './subcomponents/message';
import { FilmContextInstance } from './types/context';
import { defaultFilmContextProps, filmContextPropsValidator } from './types/props';
const b = bemClassBuilder('v-film-context');
const FilmContext = observer(props => {
    const { filmId, displayText, assets, config } = props;
    const loadAction = useCallback(() => Promise.all([loadFilmById(filmId), loadFilmAvailability(filmId)]), [filmId]);
    const { loadingState, reload } = useLoadAction(loadAction);
    const film = getFilmById(filmId);
    const filmAvailability = getFilmAvailability(filmId);
    // Load member rewards to show reward-restricted booking periods.
    useMemberRewards();
    // TODO: Investigate if having structured data not contained in the markup is problematic. #286560
    useFilmSchema(config.structuredData, film);
    if (loadingState === LoadingState.Failure) {
        return (_jsx(FilmContextMessage, { displayText: displayText, assets: assets, messageType: FilmContextMessageType.FailedToLoadData, onRetryButtonClick: reload }));
    }
    return (_jsx(FilmContextInstance.Provider, Object.assign({ value: { filmId, film, filmAvailability } }, { children: _jsx("div", Object.assign({ className: b.block({ loading: loadingState === LoadingState.Loading }) }, { children: props.children })) })));
});
FilmContext.displayName = 'FilmContext';
/**
 * The **Film Context** component loads a film from the API and provides it to its children via the `FilmContextInstance`.
 * It will render a single error message if the film fails to load.
 */
export const FilmContextComponent = withComponentWrapper(FilmContext, defaultFilmContextProps, filmContextPropsValidator);
